import { AxiosError } from "axios";

import type { Result } from "@/types";
import API from "./api";

type AuthTokenResponse = {
	access_token: string;
};

export async function fetchAuthToken(
	tuyaCode: string,
	appSchema: string,
): Promise<Result<AuthTokenResponse, AxiosError | Error>> {
	try {
		const response = await API.post(
			"/auth/login",
			{
				grant_type: "TUYA",
				code: tuyaCode,
				appschema: appSchema,
			},
			{
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
			},
		);
		return [response.data, null];
	} catch (error) {
		if (error instanceof AxiosError) {
			return [null, error];
		}

		return [null, error as Error];
	}
}
